export enum TransportState {
  ForbiddenToTransport = -1,
  NotSubjectOfRegulation = 0,
  Accepted = 1
}
